import React from "react";
import BlogsList from "./blogsList";
import DashboardLayout from "../DashboardLayout";

const Blogs = ({ granted }) => {
  return (
    <DashboardLayout>
    <div className="p-4">
      <BlogsList granted={granted} />
    </div>
    </DashboardLayout>
  );
};

export default Blogs;
